import type { ReactNode } from 'react';
import styles from './StatTile.module.css';

interface StatTileProps {
  label: string;
  value: ReactNode;
  caption?: ReactNode;
  /** The first dashboard tile in Admin v2 is the red highlight tile. */
  highlight?: boolean;
}

export function StatTile({ label, value, caption, highlight }: StatTileProps) {
  return (
    <div
      className={[styles.tile, highlight && styles.highlight]
        .filter(Boolean)
        .join(' ')}
    >
      <p className={styles.label}>{label}</p>
      <p className={styles.value}>{value}</p>
      {caption && <p className={styles.caption}>{caption}</p>}
    </div>
  );
}
